import {ComponentPropsWithoutRef, ReactNode} from "react";

interface FlexProps extends ComponentPropsWithoutRef<'div'> {}

export default function Flex({ children, className }: FlexProps) {
  return <div className={`d-flex ${className}`}>{children}</div>;
}